/* -------------------------------------------------------------------------- */
/*                                 Query keys                                 */
/* -------------------------------------------------------------------------- */

export const queryKeys = {
	status: {
		key: 'status',
	},
	whoAmI: {
		key: 'who-am-i',
	},
	auth: {
		login: {
			key: '/login',
		},
		updatePassword: {
			key: '/auth/update_password',
		},
		user: {
			key: 'auth-user',
		},
	},
	app: {
		dashboard: {
			latestProjects: {
				key: 'latest-projects',
			},
			latestOffsets: {
				key: 'latest-offsets',
			},
			kpis: {
				key: 'statistics-kpis-brands',
			},

			kpisBrands: {
				key: 'statistics-kpis-brands',
			},
			kpisProjects: {
				key: 'statistics-kpis-projects',
			},
			kpisProjectsForDonutChart: {
				key: 'statistics-kpis-projects-donut-chart',
			},
			kpisProducers: {
				key: 'statistics-kpis-producers',
			},
			posts: {
				list: {
					key: 'posts',
				},
			},
		},
		apiTokens: {
			list: {
				key: 'api-tokens-list',
			},
		},
		productions: {
			list: {
				key: 'productions-list',
			},
		},
		aco2Token: {
			listByProject: {
				key: 'aco2-token-by-project',
			},
		},
		meterPoints: {
			list: {
				key: 'meter-points-projects',
			},
		},
		conversionFactors: {
			list: {
				key: 'conversion-factors',
			},
		},
		sites: {
			list: {
				key: 'sites',
			},
		},
		additionalities: {
			all: {
				key: 'all-additionalities',
			},
		},
		users: {
			list: {
				key: 'users',
			},
		},
		measurabilityProjects: {
			list: {
				key: 'measurability-projects',
			},
		},
		producers: {
			list: {
				key: 'producers-list',
			},
		},
		brands: {
			list: {
				key: 'brands-list',
			},
			listWithoutAdmin: {
				key: 'brands-list-without-admin',
			},
			all: {
				key: 'all-brands',
			},
		},
		offsets: {
			all: {
				key: 'all-offsets',
			},
		},
		organizations: {
			list: {
				key: 'organizations-list',
			},
		},
	},
	error: {
		key: '*',
	},
} as const;
